import { SUPPORT_PHONE_DISPLAY, SUPPORT_PHONE_TEL } from '../data/contact';

function TermsPage() {
  return (
    <div className="container" style={{ maxWidth: '900px', margin: '0 auto' }}>
      <div className="card">
        <div className="card-header">Terms and Conditions</div>
        <div className="legal-content" style={{ padding: '1rem', lineHeight: 1.65 }}>
          <p style={{ color: '#6b7280', marginTop: 0 }}>
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <h3>1. Agreement to Terms</h3>
          <p>
            These Terms and Conditions (the “Terms”) govern your access to and use of the GetSkimp
            website, web application, and related services (collectively, the “Services”). By
            accessing or using the Services, you agree to be bound by these Terms. If you do not
            agree, do not use the Services.
          </p>

          <h3>2. About Our Services</h3>
          <p>
            GetSkimp provides a software platform that helps users submit requests and collect
            information that may be used by insurance providers and licensed producers to evaluate
            eligibility and pricing for renters insurance and related products. GetSkimp is not an
            insurance company and does not itself underwrite, bind, or issue insurance policies. We
            do not provide legal, tax, or financial advice. Any insurance quotes, descriptions of
            coverage, prices, timelines, and availability are provided by third parties and are
            subject to their terms, underwriting guidelines, and applicable law.
          </p>

          <h3>3. No Insurance Advice</h3>
          <p>
            Information presented through the Services is for general informational purposes only and
            should not be considered insurance advice or a recommendation of any product or carrier.
            You are solely responsible for evaluating any insurance product and deciding whether it
            meets your needs. Please consult directly with a licensed insurance professional before
            purchasing coverage.
          </p>

          <h3>4. Eligibility and User Accounts</h3>
          <p>
            You must be at least 18 years old and able to form a binding contract to use the
            Services. You are responsible for the accuracy of the information you submit and for
            maintaining the confidentiality of your account credentials. You agree to promptly update
            any information that becomes inaccurate so that it remains true, complete, and current.
          </p>

          <h3>5. Submissions and Accuracy</h3>
          <p>
            By submitting a request, you represent that all information you provide is accurate and
            not misleading. Submitting inaccurate or incomplete information may result in denial of
            coverage, premium changes, delays, or rejection of a claim by a carrier.
          </p>

          <h3>6. Third-Party Providers</h3>
          <p>
            Our Services may present offers, quotes, links, or forms hosted by third-party carriers
            or producers. Those parties are solely responsible for their content, products, and
            services. GetSkimp is not responsible for errors, omissions, delays, or decisions made by
            third parties. Your interactions with those providers are governed by their own terms and
            privacy policies.
          </p>

          <h3>7. No Guarantee of Coverage or Price</h3>
          <p>
            Submitting a request does not guarantee that you will be offered insurance, that you will
            be eligible for any particular coverage, or that any quoted price will remain available.
            All insurance is subject to underwriting, verification, and the terms of the policy
            issued by the carrier.
          </p>

          <h3>8. Acceptable Use</h3>
          <p>
            You agree not to misuse the Services or attempt to interfere with their normal operation,
            including (without limitation) by scraping, reverse engineering, probing for
            vulnerabilities, attempting to access another user’s account, or using the Services for
            any unlawful, deceptive, or fraudulent purpose.
          </p>

          <h3>9. Intellectual Property</h3>
          <p>
            The Services, including their design, text, graphics, software, and trademarks, are owned
            by GetSkimp or its licensors and are protected by intellectual property laws. Except as
            expressly permitted, you may not copy, modify, distribute, or create derivative works
            based on the Services.
          </p>

          <h3>10. Privacy</h3>
          <p>
            Your use of the Services is also governed by our Privacy Policy. By using the Services,
            you consent to our collection and use of information as described there.
          </p>

          <h3>11. Disclaimers</h3>
          <p>
            THE SERVICES ARE PROVIDED “AS IS” AND “AS AVAILABLE” WITHOUT WARRANTIES OF ANY KIND,
            WHETHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON‑INFRINGEMENT.
            GETSKIMP DOES NOT WARRANT THAT THE SERVICES WILL BE UNINTERRUPTED OR ERROR‑FREE, OR THAT
            ANY INFORMATION PROVIDED IS COMPLETE, CURRENT, OR ACCURATE.
          </p>

          <h3>12. Limitation of Liability</h3>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, GETSKIMP AND ITS AFFILIATES, OFFICERS, EMPLOYEES,
            AND AGENTS WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR
            PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUE, WHETHER INCURRED DIRECTLY OR
            INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING
            FROM YOUR USE OF (OR INABILITY TO USE) THE SERVICES. IN NO EVENT WILL OUR TOTAL LIABILITY
            EXCEED THE GREATER OF ONE HUNDRED U.S. DOLLARS (US$100) OR THE AMOUNT YOU PAID TO
            GETSKIMP FOR THE SERVICES IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM.
          </p>

          <h3>13. Changes to the Services and the Terms</h3>
          <p>
            We may modify the Services and these Terms at any time. Material changes will be posted
            in the application. Your continued use of the Services after changes become effective
            constitutes your acceptance of the revised Terms.
          </p>

          <h3>14. Termination</h3>
          <p>
            We may suspend or terminate your access to the Services at any time for any reason,
            including if we believe you have violated these Terms. Upon termination, your right to
            use the Services will stop immediately.
          </p>

          <h3>15. Governing Law</h3>
          <p>
            These Terms are governed by the laws of the State of Texas, without regard to its
            conflict of law principles. Any dispute arising from or relating to these Terms or the
            Services will be resolved in the state or federal courts located in Harris County, Texas,
            and you consent to the jurisdiction of those courts.
          </p>

          <h3>16. Contact Us</h3>
          <p>
            Questions about these Terms? Contact us at&nbsp;
            <a href="mailto:support@getskimp.com">support@getskimp.com</a>
            &nbsp;or call&nbsp;
            <a href={SUPPORT_PHONE_TEL}>{SUPPORT_PHONE_DISPLAY}</a>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default TermsPage;


